import React, { useState } from 'react'
import PropTypes from 'prop-types'
import MultiSelectionDropdown from 'components/multiSelectDropdown'
import { FiltersContentContainer } from '../style'
import qs from 'query-string'

export const getEcoRegionUrl = (ecoRegionList) => {
  return qs.stringify({
    ecoRegionId: ecoRegionList.toString()
  })
}

const EcologicalFiltersContent = ({ item, updateFilters, filterTitle, ecoregionOptions }) => {
  const [ecoregionList, setEcoregionList] = useState(item.ecoregionList)
  const [ecoregionQuery, setEcoregionQuery] = useState('')

  const handleCHangeEcoregionList = (e) => {
    setEcoregionList(e)
    updateFilters({ ...item, ecoregionList: e, url: getEcoRegionUrl(e) }, filterTitle)
  }

  const handleChangeEcoregionQuery = (e) => {
    setEcoregionQuery(e)
  }

  return (
    <FiltersContentContainer>
      <MultiSelectionDropdown
        dataTest='Ecoregion'
        marginTop='16px'
        label='ecoregion'
        secondStepOptions={ecoregionOptions}
        value={ecoregionList}
        saveChanges={handleCHangeEcoregionList}
        infoTooltip='ecoregionFilterHint'
        inputValue={ecoregionQuery}
        onInputChange={handleChangeEcoregionQuery}
        isSearchable={true}
        placeholder='selectEcoregion'
        selectAllOption={true}
      />
    </FiltersContentContainer>
  )
}

EcologicalFiltersContent.propTypes = {
  item: PropTypes.shape({
    ecoregionList: PropTypes.arrayOf(PropTypes.number)
  }).isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterTitle: PropTypes.string.isRequired,
  ecoregionOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  })).isRequired
}

export default EcologicalFiltersContent
